import {createMuiTheme} from "@material-ui/core";

export const Theme = createMuiTheme({
    palette: {
        primary: {
            light: '#FF5c8D',
            main: '#D81B60',
            dark: '#A00037',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#E5FFFF',
            main: '#B2DFDB',
            dark: '#82ADA9',
            contrastText: '#000000',
        },
        error: {
            main: '#CC0000',
        }
    },
});
